import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["defaultIndex", "vertical", "manual", "onChange", "selectedIndex"],
    _excluded2 = ["id"],
    _excluded3 = ["id", "tabIndex"];

var _ce;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _, { Fragment as ne, createContext as V, useContext as Q, useMemo as F, useReducer as re, useRef as K } from "react";
import { render as w, Features as Y, forwardRefWithAs as v } from '../../utils/render.js';
import { useId as Z } from '../../hooks/use-id.js';
import { match as G } from '../../utils/match.js';
import { Keys as P } from '../../components/keyboard.js';
import { focusIn as h, Focus as g, sortByDomNode as H, FocusResult as k } from '../../utils/focus-management.js';
import { useIsoMorphicEffect as O } from '../../hooks/use-iso-morphic-effect.js';
import { useSyncRefs as U } from '../../hooks/use-sync-refs.js';
import { useResolveButtonType as ae } from '../../hooks/use-resolve-button-type.js';
import { useLatestValue as J } from '../../hooks/use-latest-value.js';
import { FocusSentinel as le } from '../../internal/focus-sentinel.js';
import { useEvent as D } from '../../hooks/use-event.js';
import { microTask as oe } from '../../utils/micro-task.js';
import { Hidden as se } from '../../internal/hidden.js';
import { getOwnerDocument as ie } from '../../utils/owner.js';
import { StableCollection as pe, useStableCollectionIndex as ee } from '../../utils/stable-collection.js';

var ue = function (t) {
  return t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t;
}(ue || {}),
    Te = function (o) {
  return o[o.Less = -1] = "Less", o[o.Equal = 0] = "Equal", o[o.Greater = 1] = "Greater", o;
}(Te || {}),
    de = function (r) {
  return r[r.SetSelectedIndex = 0] = "SetSelectedIndex", r[r.RegisterTab = 1] = "RegisterTab", r[r.UnregisterTab = 2] = "UnregisterTab", r[r.RegisterPanel = 3] = "RegisterPanel", r[r.UnregisterPanel = 4] = "UnregisterPanel", r;
}(de || {});

var ce = (_ce = {}, _defineProperty(_ce, 0, function _(e, n) {
  var u;

  var t = H(e.tabs, function (T) {
    return T.current;
  }),
      o = H(e.panels, function (T) {
    return T.current;
  }),
      s = t.filter(function (T) {
    var l;
    return !((l = T.current) != null && l.hasAttribute("disabled"));
  }),
      r = _objectSpread(_objectSpread({}, e), {}, {
    tabs: t,
    panels: o
  });

  if (n.index < 0 || n.index > t.length - 1) {
    var _G2, _G3;

    var T = G(Math.sign(n.index - e.selectedIndex), (_G2 = {}, _defineProperty(_G2, -1, function () {
      return 1;
    }), _defineProperty(_G2, 0, function _() {
      var _G;

      return G(Math.sign(n.index), (_G = {}, _defineProperty(_G, -1, function () {
        return 0;
      }), _defineProperty(_G, 0, function _() {
        return 0;
      }), _defineProperty(_G, 1, function _() {
        return 1;
      }), _G));
    }), _defineProperty(_G2, 1, function _() {
      return 0;
    }), _G2));
    return s.length === 0 ? r : _objectSpread(_objectSpread({}, r), {}, {
      selectedIndex: G(T, (_G3 = {}, _defineProperty(_G3, 0, function _() {
        return t.indexOf(s[0]);
      }), _defineProperty(_G3, 1, function _() {
        return t.indexOf(s[s.length - 1]);
      }), _G3))
    });
  }

  var i = t.slice(0, n.index),
      b = [].concat(_toConsumableArray(t.slice(n.index)), _toConsumableArray(i)).find(function (T) {
    return s.includes(T);
  });
  if (!b) return r;
  var c = (u = t.indexOf(b)) != null ? u : e.selectedIndex;
  return c === -1 && (c = e.selectedIndex), _objectSpread(_objectSpread({}, r), {}, {
    selectedIndex: c
  });
}), _defineProperty(_ce, 1, function _(e, n) {
  var r;
  if (e.tabs.includes(n.tab)) return e;
  var t = e.tabs[e.selectedIndex],
      o = H([].concat(_toConsumableArray(e.tabs), [n.tab]), function (i) {
    return i.current;
  }),
      s = (r = o.indexOf(t)) != null ? r : e.selectedIndex;
  return s === -1 && (s = e.selectedIndex), _objectSpread(_objectSpread({}, e), {}, {
    tabs: o,
    selectedIndex: s
  });
}), _defineProperty(_ce, 2, function _(e, n) {
  return _objectSpread(_objectSpread({}, e), {}, {
    tabs: e.tabs.filter(function (t) {
      return t !== n.tab;
    })
  });
}), _defineProperty(_ce, 3, function _(e, n) {
  return e.panels.includes(n.panel) ? e : _objectSpread(_objectSpread({}, e), {}, {
    panels: H([].concat(_toConsumableArray(e.panels), [n.panel]), function (t) {
      return t.current;
    })
  });
}), _defineProperty(_ce, 4, function _(e, n) {
  return _objectSpread(_objectSpread({}, e), {}, {
    panels: e.panels.filter(function (t) {
      return t !== n.panel;
    })
  });
}), _ce),
    X = V(null);
X.displayName = "TabsDataContext";

function M(e) {
  var n = Q(X);

  if (n === null) {
    var t = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, M), t;
  }

  return n;
}

var $ = V(null);
$.displayName = "TabsActionsContext";

function q(e) {
  var n = Q($);

  if (n === null) {
    var t = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, q), t;
  }

  return n;
}

function fe(e, n) {
  return G(n.type, ce, e, n);
}

var be = ne;

function me(e, n) {
  var _e$defaultIndex = e.defaultIndex,
      t = _e$defaultIndex === void 0 ? 0 : _e$defaultIndex,
      _e$vertical = e.vertical,
      o = _e$vertical === void 0 ? !1 : _e$vertical,
      _e$manual = e.manual,
      s = _e$manual === void 0 ? !1 : _e$manual,
      r = e.onChange,
      _e$selectedIndex = e.selectedIndex,
      i = _e$selectedIndex === void 0 ? null : _e$selectedIndex,
      R = _objectWithoutProperties(e, _excluded);

  var b = o ? "vertical" : "horizontal",
      c = s ? "manual" : "auto";

  var u = i !== null,
      T = U(n),
      _re = re(fe, {
    selectedIndex: i != null ? i : t,
    tabs: [],
    panels: []
  }),
      _re2 = _slicedToArray(_re, 2),
      l = _re2[0],
      d = _re2[1],
      y = F(function () {
    return {
      selectedIndex: l.selectedIndex
    };
  }, [l.selectedIndex]),
      m = J(r || function () {}),
      x = J(l.tabs),
      E = F(function () {
    return _objectSpread({
      orientation: b,
      activation: c
    }, l);
  }, [b, c, l]),
      S = D(function (p) {
    return d({
      type: 1,
      tab: p
    }), function () {
      return d({
        type: 2,
        tab: p
      });
    };
  }),
      A = D(function (p) {
    return d({
      type: 3,
      panel: p
    }), function () {
      return d({
        type: 4,
        panel: p
      });
    };
  }),
      L = D(function (p) {
    C.current !== p && m.current(p), u || d({
      type: 0,
      index: p
    });
  }),
      C = J(u ? e.selectedIndex : l.selectedIndex),
      N = F(function () {
    return {
      registerTab: S,
      registerPanel: A,
      change: L
    };
  }, []);

  O(function () {
    d({
      type: 0,
      index: i != null ? i : t
    });
  }, [i]), O(function () {
    if (C.current === void 0 || l.tabs.length <= 0) return;
    var p = H(l.tabs, function (a) {
      return a.current;
    });
    p.some(function (a, f) {
      return l.tabs[f] !== a;
    }) && L(p.indexOf(l.tabs[C.current]));
  });
  var B = {
    ref: T
  };
  return _.createElement(pe, null, _.createElement($.Provider, {
    value: N
  }, _.createElement(X.Provider, {
    value: E
  }, E.tabs.length <= 0 && _.createElement(le, {
    onFocus: function onFocus() {
      var p, I;

      var _iterator = _createForOfIteratorHelper(x.current),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var a = _step.value;
          if (((p = a.current) == null ? void 0 : p.tabIndex) === 0) return (I = a.current) == null || I.focus(), !0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return !1;
    }
  }), w({
    ourProps: B,
    theirProps: R,
    slot: y,
    defaultTag: be,
    name: "Tabs"
  }))));
}

var Pe = "div";

function ge(e, n) {
  var _M = M("Tab.List"),
      t = _M.orientation,
      o = _M.selectedIndex,
      s = U(n);

  return w({
    ourProps: {
      ref: s,
      role: "tablist",
      "aria-orientation": t
    },
    theirProps: e,
    slot: {
      selectedIndex: o
    },
    defaultTag: Pe,
    name: "Tabs.List"
  });
}

var ye = "button";

function xe(e, n) {
  var p, I;

  var t = Z(),
      _e$id = e.id,
      o = _e$id === void 0 ? "headlessui-tabs-tab-".concat(t) : _e$id,
      s = _objectWithoutProperties(e, _excluded2),
      _M2 = M("Tab"),
      r = _M2.orientation,
      i = _M2.activation,
      R = _M2.selectedIndex,
      b = _M2.tabs,
      c = _M2.panels,
      u = q("Tab"),
      T = M("Tab"),
      l = K(null),
      d = U(l, n);

  O(function () {
    return u.registerTab(l);
  }, [u, l]);
  var y = ee("tabs"),
      m = b.indexOf(l);
  m === -1 && (m = y);
  var x = m === R,
      E = D(function (a) {
    var j;
    var f = a();

    if (f === k.Success && i === "auto") {
      var W = (j = ie(l)) == null ? void 0 : j.activeElement,
          z = T.tabs.findIndex(function (te) {
        return te.current === W;
      });
      z !== -1 && u.change(z);
    }

    return f;
  }),
      S = D(function (a) {
    var f = b.map(function (W) {
      return W.current;
    }).filter(Boolean);

    if (a.key === P.Space || a.key === P.Enter) {
      a.preventDefault(), a.stopPropagation(), u.change(m);
      return;
    }

    switch (a.key) {
      case P.Home:
      case P.PageUp:
        return a.preventDefault(), a.stopPropagation(), E(function () {
          return h(f, g.First);
        });

      case P.End:
      case P.PageDown:
        return a.preventDefault(), a.stopPropagation(), E(function () {
          return h(f, g.Last);
        });
    }

    if (E(function () {
      return G(r, {
        vertical: function vertical() {
          return a.key === P.ArrowUp ? h(f, g.Previous | g.WrapAround) : a.key === P.ArrowDown ? h(f, g.Next | g.WrapAround) : k.Error;
        },
        horizontal: function horizontal() {
          return a.key === P.ArrowLeft ? h(f, g.Previous | g.WrapAround) : a.key === P.ArrowRight ? h(f, g.Next | g.WrapAround) : k.Error;
        }
      });
    }) === k.Success) return a.preventDefault();
  }),
      A = K(!1),
      L = D(function () {
    var a;
    A.current || (A.current = !0, (a = l.current) == null || a.focus(), u.change(m), oe(function () {
      A.current = !1;
    }));
  }),
      C = D(function (a) {
    a.preventDefault();
  }),
      N = F(function () {
    return {
      selected: x
    };
  }, [x]),
      B = {
    ref: d,
    onKeyDown: S,
    onMouseDown: C,
    onClick: L,
    id: o,
    role: "tab",
    type: ae(e, l),
    "aria-controls": (I = (p = c[m]) == null ? void 0 : p.current) == null ? void 0 : I.id,
    "aria-selected": x,
    tabIndex: x ? 0 : -1
  };
  return w({
    ourProps: B,
    theirProps: s,
    slot: N,
    defaultTag: ye,
    name: "Tabs.Tab"
  });
}

var Ee = "div";

function Ae(e, n) {
  var _M3 = M("Tab.Panels"),
      t = _M3.selectedIndex,
      o = U(n),
      s = F(function () {
    return {
      selectedIndex: t
    };
  }, [t]);

  return w({
    ourProps: {
      ref: o
    },
    theirProps: e,
    slot: s,
    defaultTag: Ee,
    name: "Tabs.Panels"
  });
}

var Re = "div",
    Le = Y.RenderStrategy | Y.Static;

function De(e, n) {
  var E, S, A, L;

  var t = Z(),
      _e$id2 = e.id,
      o = _e$id2 === void 0 ? "headlessui-tabs-panel-".concat(t) : _e$id2,
      _e$tabIndex = e.tabIndex,
      s = _e$tabIndex === void 0 ? 0 : _e$tabIndex,
      r = _objectWithoutProperties(e, _excluded3),
      _M4 = M("Tab.Panel"),
      i = _M4.selectedIndex,
      R = _M4.tabs,
      b = _M4.panels,
      c = q("Tab.Panel"),
      u = K(null),
      T = U(u, n);

  O(function () {
    return c.registerPanel(u);
  }, [c, u]);
  var l = ee("panels"),
      d = b.indexOf(u);
  d === -1 && (d = l);
  var y = d === i,
      m = F(function () {
    return {
      selected: y
    };
  }, [y]),
      x = {
    ref: T,
    id: o,
    role: "tabpanel",
    "aria-labelledby": (S = (E = R[d]) == null ? void 0 : E.current) == null ? void 0 : S.id,
    tabIndex: y ? s : -1
  };
  return !y && ((A = r.unmount) == null || A) && !((L = r.static) != null && L) ? _.createElement(se, _objectSpread({
    as: "span"
  }, x)) : w({
    ourProps: x,
    theirProps: r,
    slot: m,
    defaultTag: Re,
    features: Le,
    visible: y,
    name: "Tabs.Panel"
  });
}

var Se = v(xe),
    Ie = v(me),
    Fe = v(ge),
    he = v(Ae),
    Me = v(De),
    rt = Object.assign(Se, {
  Group: Ie,
  List: Fe,
  Panels: he,
  Panel: Me
});
export { rt as Tab };